import {
  configureAuth,
  signIn,
  completeNewPassword,
  signOut,
  isLoggedIn,
  getUsername,
} from "./auth";
import { initApp, stopPolling } from "./app";

const $ = (id: string) => document.getElementById(id)!;

let pendingNewPassword = false;

function showApp(): void {
  $("auth-screen").classList.add("hidden");
  $("app-screen").classList.remove("hidden");
  getUsername().then((name) => {
    $("user-label").textContent = name;
  });
  initApp();
}

function showLogin(): void {
  $("app-screen").classList.add("hidden");
  $("auth-screen").classList.remove("hidden");
  stopPolling();
}

// ── Login form ───────────────────────────────────────────────────────
$("login-form").addEventListener("submit", async (e) => {
  e.preventDefault();
  const errorEl = $("auth-error");
  errorEl.textContent = "";

  const username = (document.getElementById("auth-username") as HTMLInputElement).value.trim();
  const password = (document.getElementById("auth-password") as HTMLInputElement).value;

  if (pendingNewPassword) {
    try {
      await completeNewPassword(password);
      pendingNewPassword = false;
      $("auth-submit").textContent = "SIGN IN";
      (document.getElementById("auth-password") as HTMLInputElement).placeholder = "password";
      showApp();
    } catch (err: unknown) {
      errorEl.textContent = (err as Error).message || "Password change failed";
    }
    return;
  }

  try {
    const result = await signIn(username, password);
    if (result.needsNewPassword) {
      pendingNewPassword = true;
      errorEl.textContent = "Set a new password below.";
      (document.getElementById("auth-password") as HTMLInputElement).value = "";
      (document.getElementById("auth-password") as HTMLInputElement).placeholder = "new password";
      $("auth-submit").textContent = "SET PASSWORD";
    } else {
      showApp();
    }
  } catch (err: unknown) {
    errorEl.textContent = (err as Error).message || "Sign in failed";
  }
});

// ── Logout ───────────────────────────────────────────────────────────
$("logout-btn").addEventListener("click", async () => {
  await signOut();
  showLogin();
});

// ── Boot ─────────────────────────────────────────────────────────────
configureAuth();
isLoggedIn().then((loggedIn) => {
  if (loggedIn) {
    showApp();
  } else {
    showLogin();
  }
});
